import { string } from 'prop-types'
import React from 'react'
import MapViewMap from './MapViewMap'

const MapView = (props) => {
  return (
    <div className="map-view view">
      <MapViewMap />
    </div>
  )
}
MapView.propTypes = {
}

export default MapView
